<template>
    <div class="page-wrapper">
        <TopBarGray
            :title="lbl.pointGuide.title"
            @clickBack="clickBack()">
        </TopBarGray>
        <div class="page-content page-point-guideline">
            <div class="wrapper-tab">
                <div class="tab-reward" v-for="(productDetail, k) in listProduct" :key="k"
                    :class="{'active': activeTab == productDetail.id}"
                    @click="clickTab(productDetail.id)">
                        {{productDetail.point}}
                        <img class="icon-active" src="@/assets/icon/reward_coin_active@2x.png" v-if="activeTab == productDetail.id">
                        <img class="icon-coin" src="@/assets/icon/reward_icon_coin@2x.png" v-else> 
                </div>
            </div>
            <ProductPointList
                :activeTab="activeTab"
                 @toggleLoading="toggleLoading($event)" >
            </ProductPointList>
        </div>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
//helper
import CacheHelper from "@/helper/CacheHelper.js";
//core
import ProductPointConfig from "@/core/ProductPointDetail/ProductPointConfig.js";
//component
import ProductPointList from "../component/ProductPointList.vue";
import TopBarGray from '@/components/Layout/TopBarPage/TopBarGray.vue';

export default {
    name: "PointGuideline",
    mixins: [LocaleMixin, ModalMixin],
    components: {
        ProductPointList,
        TopBarGray
    },
    data: function() {
        return {
            activeTab: '1',
            listProduct: [],

            isListLoading: false,
            cache:  new CacheHelper('session'),
        };
    },
    created: function() {
        this.productList();
    },
    mounted: function() {
        this.clickTab(this.activeTab);
    },
    methods: {
        productList: function(){
            ProductPointConfig.apiGetProductPoint().subscribe(res => {
                console.log("res",res);
                this.listProduct = res;
            });
        },
        clickTab: function (strtab) {
           this.activeTab = strtab;
           this.$emit("changeTab", this.activeTab);
        },
        clickBack: function(){
            if(this.cache.getCache('isFromBDMPoint')){
                this.showSkipModal();
            }else if(this.cache.getCache('isFromBDMPointLogin')){
                this.cache.removeCache('isFromBDMPointLogin');
                window.location.replace('/point');
            }else{
                this.$router.back();
            }
        },
        showSkipModal: function(){
            var lbl_page = this.lbl.modalSkip;
            var skip_title = lbl_page.collect_points.title;
            var skip_msg = lbl_page.collect_points.msg;
            
            this.skipModal
                .setTitle(skip_title)
                .setMsg(skip_msg)
                .setBtnOk(lbl_page.btn_confirm)
                .setTag('skip-login-point')
                .show();
            
            this.skipModal.onClickOk((data) =>{
                if(data.tag == 'skip-login-point'){
                    this.cache.removeCache('isFromBDMPoint');
                    window.location.replace('/linelogin');
                }
            });

        },
        showLoading: function() {
            setTimeout(() => {
                this.loadingModal.show();
            },0)
        },
        hideLoading: function() {
            setTimeout(() => {
                this.loadingModal.hide();
            },300)
        },
        toggleLoading: function (isListLoading) {
            this.isListLoading = isListLoading;
            if(this.isListLoading){
                this.showLoading();
            }else{
                this.hideLoading();
            }
        },
    }
}
</script>
<style lang='scss' scoped>
@import "@/style/base/base.scss";
.page-point-guideline{
    @include content-curve;
}
.wrapper-tab {
    display: flex;
    padding: 20px 15px;

    .tab-reward {
        width: 50%;
        text-align: center;
        color: $border-gray;
        font-family: $medium;
        font-size: 1.25rem;
        border-bottom: solid 1px rgba($light-gray, 0.19);
        
        .icon-coin {
            border-radius: 50px;
            box-shadow: $box-shadow;
            border: solid 1.5px $border-gray;
            margin-bottom: 6px;
            width: 25px;
            height: 25px;
        }

        .icon-active {
            width: 35px;
            height: 35px;
        }

        &.active {
            color: $dark-blue;
            border-bottom: 3px solid $dark-blue;
        }

        @include mini-mobile {
            font-size: 1rem;
            .icon-coin {
                width: 19px;
                height: 19px;
            }
            .icon-active {
                width: 24px;
                height: 24px;
            }
        }
    }
}
</style>
